import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Login.module.css'; // reuse login styles
import logo from "./Alayaa.png";

const NotFound = () => {
  return (
    <div className={`${styles.loginContainer} d-flex align-items-center justify-content-center min-vh-100`}>
      <div className="col-lg-5 col-md-8 col-12">
        <div className={`${styles.card} card shadow-lg border-0 text-center`}>
          <div className="card-body p-5">
            <div className="display-1 fw-bold text-muted mb-4">404</div>
            <h2 className="fw-bold mb-3">Page Not Found</h2>
            <p className="text-muted mb-4">
              Oops! The page you are looking for does not exist.
            </p>
            <Link to="/" className={`${styles.submitBtn} btn w-50`}>
              <i className="fas fa-home me-2"></i> Go to Home
            </Link>
          </div>
          <div className="card-footer text-center border-0 bg-transparent pb-4">
            <p className="text-muted small mb-0">
              Al-Alia · Conference Attendance Management
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;